import React from "react";
import Navigation from "../partials/Navigation";
import { useParams } from 'react-router-dom';
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import SingleOrganization from "../partials/Organization/SingleOrganization";
import AllOrganizations from "../partials/Organization/AllOrganizations";
import {Helmet} from "react-helmet";

const Organization = () => {

    const { organization_id } = useParams();

    return (
        <div className="main-wrapper">

            <Helmet>
				<title>Organisationer</title>
				<meta name="description" content="" />
			</Helmet>

            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="Organisationer" />

                <div className="pt-5 pt-lg-0 page-content-inner">
                    <div className="col pt-3">
                        { organization_id &&
                            <SingleOrganization />
                        }
                        { !organization_id &&
                            <AllOrganizations />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Organization;
